<template>
  <div class="retrueve_pass">
    <div v-if="steps === 0">
      <mt-header title="Retrieve Password">
        <span slot="left" @click="()=>this.$router.back()">
          <i class="iconfont icon-left"></i>
          Return
        </span>
      </mt-header>
      <div class="retrueve_item">
        <p class="retrieve_p">Please input the email account to reset your password</p>
        <el-form :model="obj" ref="retrievePassword" :rules="rules" class="demo-dynamic">
          <el-form-item prop="email">
            <el-input v-model="obj.email" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input class="input_Code" v-model="obj.code" placeholder="Input the verification code"></el-input>
            <el-button class="btn_Code" type="primary" @click="sendCode" :disabled="codeFalg">{{countdown}}</el-button>
          </el-form-item>
          <el-form-item class="btnGroup">
            <el-button class="btn" type="primary" @click="submitForm('retrievePassword')">Next Step</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-else-if="steps === 1">
      <mt-header title="Set a new password">
        <span slot="left" @click="()=>this.$router.push('/exhibitor')">
          <i class="iconfont icon-left"></i>
          Return
        </span>
      </mt-header>
      <div class="retrueve_item">
        <p class="retrieve_p">Please set a new password of <span style="color:#008baf">{{obj.email}}</span>. It is recommended to use a combination of numbers, letters and characters to improve the security level of the password</p>
        <el-form :model="obj" ref="retrievePassword1" :rules="rules" class="demo-dynamic">
          <el-form-item prop="pwd">
            <el-input v-model="obj.pwd" placeholder="Input password" show-password></el-input>
          </el-form-item>
          <el-form-item class="btnGroup">
            <el-button class="btn" type="primary" @click="submitForm1('retrievePassword1')">Yes</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Header } from 'mint-ui';
import { reqRetrieveCode, reqRetrieveCodeTwo, reqNewPwd } from "../../../api";

export default {
  components:{
    'mt-header':Header,
  },
  data(){
    var validateEmail = (rule, value, callback)=>{
      if (value === '') {
        this.codeFalg = true
        callback(new Error('Email address is required'));
      } else if(!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)){
        this.codeFalg = true
        callback(new Error('Input email address'));
      } else {
        this.codeFalg = false
        // console.log(this.codeFalg);
        callback();
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Input password'));
      } else if(value.length<6||value.length>16){
        callback(new Error('Input a 6-15 digit password'));
      } else {
        callback();
      }
    };
    return{
      steps:0,
      codeFalg:true,//验证码判定条件
      countdown:'verification code',
      rules:{
        email:[
          { validator: validateEmail, trigger: 'blur' }
        ],
        pwd:[
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      obj:{
        email:'',
        code:'',
        pwd:''
      },
    }
  },
  methods:{
    async sendCode(){//发送验证码
      const response = await reqRetrieveCode({email:this.obj.email})
      // console.log(response);
      if (response.code*1==1) {
        Toast({position: 'top',message: 'Not registered yet'})
      }else if(response.code*1==3){
        Toast({position: 'top',message: 'Sent successfully'})
        this.countdown = 90
        this.codeFalg = true
        this.time()
      }else{
        Toast({position: 'top',message: 'Sent failure'})
      }
    },
    time(){//倒计时
      this.timer = setInterval(()=>{
        this.countdown--
        if (this.countdown<=0) {
          clearInterval(this.timer)
          this.countdown = "verification code"
          this.codeFalg = false
        }
      },1000)
    },
    submitForm(formName){
      this.$refs[formName].validate( async (valid) => {
        if (valid) {//提交表单数据，发送请求
        const response = await reqRetrieveCodeTwo({email:this.obj.email,code:this.obj.code})
        // console.log(response);
        if (response.code*1==2) {
          this.steps=1
        }else{
          Toast({position: 'top',message: 'Email and verification code are required'})
        }
        } else {
          return false;
        }
      })
    },
    submitForm1(formName){
      // console.log(this.obj.pwd);
      this.$refs[formName].validate( async (valid) => {
        if (valid) {//提交表单数据，发送请求
          const response = await reqNewPwd({pwd:this.obj.pwd})
          // console.log(response);
          if (response.code*1==2) {
            Toast({position: 'top',message: 'Modified successfully'})
            this.$router.push('/home')
            this.$store.dispatch("dialog",true)
          }else{
            Toast({position: 'top',message: 'Modified failure'})
          }
        } else {
          return false;
        }
      })
    }
  }

}
</script>

<style scoped>
  .retrueve_pass{
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: white;
    background-image: url('https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/login_bg.png');
    background-size: 100% 100%;
  }
  .retrueve_item{
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    /* padding-top: 20px; */
    max-width: 300px;
    width: 100%;
    margin: auto;
    color: #b8b8b8;
  }
  .retrieve_p{
    line-height: 24px;
    font-size: 14px;
    padding-bottom: 10px;
  }
  .input_Code{
    width: calc(100% - 130px);
    margin-right: 18px;
  }
  .btn_Code{
    width: 112px;
    padding-left: 0;
    padding-right: 0;
  }
  .btn{
    width: 100%;
    margin-top: 40px;
  }
</style>